import { useCallback } from "react";
import { paths } from "render/routes/paths";
import { InformationLayout } from "render/ui/layout/InformationLayout/InformationLayout";
import { PageFrameContent } from "render/ui/layout/PageFrameContent/PageFrameContent";
import { Button, Icon24ArrowRight, Typography } from "@cur8/maneki";

type CheckOutViewProps = {
  goTo(url: string): void;
};

export function CheckOutView({ goTo }: CheckOutViewProps) {
  const handleContinue = useCallback(async () => {
    const url = paths.root.url({});
    goTo(url);
  }, [goTo]);

  return (
    <PageFrameContent>
      <InformationLayout
        content={
          <>
            <Typography variant="display-s">Ready to check-out?</Typography>
            <Typography variant="body-m" color="subtle">
              Check out if all examinations are complete
            </Typography>
          </>
        }
        buttons={
          <Button
            onPress={handleContinue}
            fillContainer
            icon={<Icon24ArrowRight />}
          >
            Check-out
          </Button>
        }
      />
    </PageFrameContent>
  );
}
